import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';

import { ErrorHandlingConfigurationBaseLoader } from '../error-handling.config';

export const HttpErrorInterceptor: HttpInterceptorFn = (request, next) => {
    {
        const errorHandlingConfiguration = inject(ErrorHandlingConfigurationBaseLoader);
        return next(request).pipe(
            catchError((error) => {
                // The 401 status is handled by the AuthModule
                if (error instanceof HttpErrorResponse && error.status !== 401) {
                    errorHandlingConfiguration.getHttpErrorResponseCallback()(error);
                }
                return throwError(() => error);
            }),
        );
    }
};
